module.exports = __webpack_public_path__ + "img/B1.e1813b26.png";